import { Link } from "react-router-dom";
import { hero } from "@/mocks/ranking";

const stats = [
  { num: "120+", label: "热点榜单" },
  { num: "36期", label: "月度总结" },
  { num: "8年", label: "吃瓜沉淀" },
];

export default function HomeHero() {
  return (
    <section className="relative flex min-h-[600px] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={hero}
          alt="吃瓜榜单年度盘点与月度总结热门话题配图"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/80 via-foreground-950/55 to-foreground-950/25"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 md:px-6">
        <p className="mb-4 inline-flex items-center gap-2 rounded-full bg-accent-500/90 px-4 py-1.5 text-sm font-semibold text-foreground-950">
          <i className="ri-fire-fill" aria-hidden="true"></i>
          吃瓜不断档 · 一键回顾
        </p>
        <h1 className="max-w-3xl text-4xl font-black leading-tight text-background-50 md:text-6xl">
          吃瓜榜单<span className="text-accent-400">年度盘点</span>
          <span className="mx-2 text-background-50/70">×</span>月度总结
        </h1>
        <p className="mt-5 max-w-2xl text-base leading-7 text-background-100 md:text-lg">
          从年度瓜王到月度黑马，把热点做成榜单、把吃瓜做成时间线。每一期都替你梳理起因、发酵与结局，错过的瓜一次全补上。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/annual"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-center font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-award-line mr-2" aria-hidden="true"></i>
            查看年度盘点
          </Link>
          <Link
            to="/monthly"
            className="whitespace-nowrap rounded-full bg-background-50/15 px-7 py-3.5 text-center font-semibold text-background-50 ring-1 ring-background-50/40 backdrop-blur transition-colors hover:bg-background-50/25"
          >
            <i className="ri-calendar-check-line mr-2" aria-hidden="true"></i>
            吃这个月的瓜
          </Link>
        </div>

        <dl className="mt-12 flex max-w-lg flex-wrap gap-x-10 gap-y-4">
          {stats.map((s) => (
            <div key={s.label}>
              <dt className="text-xs uppercase tracking-widest text-background-100/80">{s.label}</dt>
              <dd className="font-display text-3xl text-accent-400">{s.num}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="absolute bottom-0 left-0 h-10 w-full bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}